export default __webpack_public_path__ + "static/media/img-slider-urban-transit-5.c0873728.png";